<template>
    <li class="vehicle-details__key-specification-item" >
        <svg class="vehicle-details__key-specification-item--icon" width="36.5" height="36.5">
            <use :href="`${svg}`"/>
        </svg>
        <div class="vehicle-details__key-specification-item--content">
            <span class="vehicle-details__key-specification-item--label">{{ label }}</span>
            <span class="vehicle-details__key-specification-item--value">{{ value }}</span>
        </div>
    </li>
</template>

<script>
export default {
    props: [
        'svg',
        'label',
        'value'
    ]
}
</script>

<style lang="scss" scoped>
@import "../../../sass/redesign/variables";

.vehicle-details {
    &__key-specification-item {
        display: flex;
        flex-direction: row;
        list-style: none;
        padding: 0;

        &--icon {
            fill: $blue-price;
            align-self: flex-start;
            flex-shrink: 0;
            width: 36.5px;
            height: 36.5px;
        }

        &--content {
            flex-grow: 1;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: start;
            gap: 5px;
            margin-left: 10px;
        }

        &--label {
            font-size: 10px;
            font-weight: 600;
            text-transform: uppercase;
            line-height: 1;
            color: #747474;
        }

        &--value {
            font-size: 16px;
            font-weight: 600;
            line-height: 1;
        }
    }
}
</style>